<template>
  <v-text-field
    maxlength="9"
    outlined
    hide-details="auto"
    :rules="[rules.contactCredentials(entity), rules.optionalPhoneNumber]"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-text-field>
</template>

<script>
import formValidationRules from '@/core/utils/form-validation-rules';

export default {
  name: 'PhoneField',
  inheritAttrs: false,
  props: {
    entity: {
      required: true,
    },
  },
  data() {
    return {
      rules: formValidationRules,
    };
  },
};
</script>
